import {MenuPanels} from '../../models/UIModel.js';
import {isStoreItemLocked, lockImage, ShoppeBase} from './shoppe-base.js';
import {
    Column,
    Container,
    Image,
    Panel,
    Row,
    Text,
} from '@wonderlandengine/react-ui/components';
import {Align, FlexDirection, Justify} from '@wonderlandengine/react-ui';
import {goToPreviousMenu} from '../utils/goToPreviousMenu.js';
import {UiTexturesManager} from '../components/ui-textures-manager.js';
import {Carousel, CarouselItem} from '../components/carousel.js';
import {SliderItem} from '../components/SliderComponent.js';
import {StoreInventoryItems} from '../../enums/StoreInventoryItems.js';
import {colorSwatch} from '../utils/colorSwatch.js';
import {Header} from '../components/header.js';
import {formatString, insertNewlines, setAlpha} from '../utils/utils.js';
import {useRotBMaterialContext} from '../utils/rotb-material-context.js';
import {useEffect, useRef, useState} from 'react';
import {PerkSelectItem} from '../../components/store-data/powerups/PerkSelectItem.js';
import {StorePowerupsData} from '../../components/store-data/powerups/StorePowerupsData.js';
import {Localization} from '../../utils/Localization.js';
import {Statistics} from '../../components/statistics.js';
import {TransactionalNames} from '../../enums/TransactionalNames.js';
import {CoinButton} from '../components/coin-button.js';
import {BuyButton} from '../components/buy-button.js';
import {buyItem} from '../utils/buyItem.js';
import {StoreManager} from '../../components/store-manager.js';
import {UnlockManager} from '../../components/unlock-manager.js';
import {formatNumber} from '../../utils/Utils.js';

export const ShoppePerks = () => {
    const mats = useRotBMaterialContext();

    const [refreshKey, setRefreshKey] = useState(0);
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [levelText, setLevelText] = useState('');
    const [inventoryAmount, setInventoryAmount] = useState('');
    const [upgradeDescription, setUpgradeDescription] = useState('');
    const [unlockDescription, setUnlockDescription] = useState('');
    const [inventoryStat, setInventoryStat] = useState<TransactionalNames>(null);
    const [upgradeStat, setUpgradeStat] = useState(null);
    const [upgradeCost, setUpgradeCost] = useState(0);
    const [isLocked, setIsLocked] = useState(true);
    const [isImplemented, setIsImplemented] = useState(true);
    const [upgradeMaxed, setUpgradeMaxed] = useState(false);
    const selectedItem = useRef<SliderItem>(null);

    const onSelectionChanged = (item: SliderItem) => {
        selectedItem.current = item;
        setRefreshKey((prev) => prev + 1);
    };

    useEffect(() => {
        if (!selectedItem.current) {
            return;
        }
        let item = selectedItem.current;
        const storeInventoryItem = StoreInventoryItems[item.id];

        const data = StorePowerupsData.instance.data.get(
            storeInventoryItem
        ) as PerkSelectItem;
        const descriptions =
            StorePowerupsData.instance.descriptions.get(storeInventoryItem);
        //setSelectedItem(data);
        setTitle(Localization.instance.get(data.title));
        setDescription(Localization.instance.get(descriptions.levelUpDescriptions[0]));
        const upgradeLevel = StoreManager.instance.getUpgradeLevel(data.stat);
        let currentDescriptionText = ' ';

        setIsImplemented(data.isImplemented);

        const locked = isStoreItemLocked(storeInventoryItem);
        if (locked) {
            setInventoryAmount(Localization.instance.get('Locked'));
            setLevelText('');
            setUpgradeMaxed(false);
            const upgradeCoinCost = StoreManager.instance.getCoinCost(data.stat);
            setUpgradeCost(upgradeCoinCost);
            setUpgradeDescription('');

            const unlockInstruct = UnlockManager.instance.getInstructionsForUnlock(
                data.lockFlag,
                0
            );
            setUnlockDescription(unlockInstruct.instructions);
        } else {
            if (upgradeLevel > 0) {
                // const currentInventory = Statistics.instance.getTransactional(
                //     data.inventoryStat
                // );
                // if (currentInventory == 0) {
                //     // do some bouncy thing
                // } else {
                //     // reset bouncy thing
                // }
                // setInventoryAmount(
                //     formatString(
                //         Localization.instance.get('YouGot'),
                //         formatNumber(currentInventory)
                //     )
                // );
                setLevelText(
                    formatString(Localization.instance.get('UpgradeLevel'), upgradeLevel)
                );

                const upgradeCoinCost = StoreManager.instance.getCoinCost(data.stat);
                setUpgradeCost(upgradeCoinCost);
                if (upgradeLevel < descriptions.levelUpDescriptions.length) {
                    setUpgradeMaxed(false);
                    const description = Localization.instance.get(
                        descriptions.levelUpDescriptions[upgradeLevel]
                    );
                    if (upgradeLevel > 0) {
                        const nextUpgrade = Localization.instance.get('NextUpgradeFormat');
                        currentDescriptionText = formatString(nextUpgrade, description);
                    }
                }
                // maxed out
                else {
                    currentDescriptionText = Localization.instance.get(
                        descriptions.levelUpDescriptions[
                            descriptions.levelUpDescriptions.length - 1
                        ]
                    );
                    setUpgradeMaxed(true);
                }
            } else {
                setLevelText('');
            }
        }
        setUpgradeDescription(currentDescriptionText);
        setUpgradeStat(data.stat);
        setIsLocked(locked);
    }, [refreshKey]);

    useEffect(() => {
        const changeCallback = () => {
            setRefreshKey((prev) => prev + 1);
        };
        Statistics.instance.registerChangedCallback(changeCallback);
        return () => {
            Statistics.instance.unRegisterChangedCallback(changeCallback);
        };
    }, []);

    return (
        <ShoppeBase
            title={Localization.instance.get('Perks')}
            onOkay={() => goToPreviousMenu(MenuPanels.StorePerks)}
        >
            <Column>
                <Carousel loop={false} onSelectionChanged={onSelectionChanged}>
                    <CarouselItem
                        title="Rainbow Fruit"
                        id={StoreInventoryItems[StoreInventoryItems.rainbowPerk]}
                        image={lockImage(
                            StoreInventoryItems.rainbowPerk,
                            UiTexturesManager.instance.rainbowFruit
                        )}
                    ></CarouselItem>
                    <CarouselItem
                        title="TNT Blobs"
                        id={StoreInventoryItems[StoreInventoryItems.tntPerk]}
                        image={lockImage(
                            StoreInventoryItems.tntPerk,
                            UiTexturesManager.instance.tntBlob
                        )}
                    ></CarouselItem>
                    <CarouselItem
                        title="Chain Bonus"
                        id={StoreInventoryItems[StoreInventoryItems.chainBonusPerk]}
                        image={lockImage(
                            StoreInventoryItems.chainBonusPerk,
                            UiTexturesManager.instance.comboChainBonus
                        )}
                    ></CarouselItem>
                    <CarouselItem
                        title="Cherry Bonus"
                        id={StoreInventoryItems[StoreInventoryItems.cherryBonusPerk]}
                        image={lockImage(
                            StoreInventoryItems.cherryBonusPerk,
                            UiTexturesManager.instance.scoreModifier
                        )}
                    ></CarouselItem>
                    <CarouselItem
                        title="Star Booster"
                        id={StoreInventoryItems[StoreInventoryItems.starBoosterPerk]}
                        image={lockImage(
                            StoreInventoryItems.starBoosterPerk,
                            UiTexturesManager.instance.starBooster
                        )}
                    ></CarouselItem>
                    <CarouselItem
                        title="Time Bonus"
                        id={StoreInventoryItems[StoreInventoryItems.addTimePerk]}
                        image={lockImage(
                            StoreInventoryItems.addTimePerk,
                            UiTexturesManager.instance.timeBonus
                        )}
                    ></CarouselItem>
                </Carousel>
                <Header
                    title={title}
                    color={colorSwatch.SubTitleHighBackground}
                    center={true}
                />
                <Container height={75} alignContent={Align.FlexStart} padding={10}>
                    <Text
                        color={setAlpha(colorSwatch.DescriptionText, '90%')}
                        material={mats.regularTextMaterial}
                        fontSize={20}
                        textAlign="center"
                    >
                        {insertNewlines(description, 48)}
                    </Text>
                </Container>
                {isLocked ? (
                    <Header title={Localization.instance.get('UnlockNow')} />
                ) : (
                    <Header
                        title={upgradeMaxed ? 'UPGRADE MAX' : 'UPGRADE'}
                        subtitle={levelText}
                    />
                )}
                {isImplemented ? (
                    <Container
                        height={70}
                        marginTop={10}
                        justifyContent={Justify.SpaceBetween}
                        alignContent={Align.Center}
                        flexDirection={FlexDirection.Row}
                    >
                        <Container flexGrow={1}>
                            <Text
                                color={setAlpha(colorSwatch.DescriptionText, '90%')}
                                material={mats.regularTextMaterial}
                                fontSize={18}
                            >
                                {insertNewlines(upgradeDescription, 36)}
                            </Text>
                        </Container>

                        <Container
                            top={-5}
                            flexGrow={0}
                            alignSelf={Align.FlexEnd}
                            justifyContent={Justify.FlexEnd}
                            marginBottom={4}
                        >
                            {!upgradeMaxed && (
                                <CoinButton
                                    price={upgradeCost}
                                    onClick={() => {
                                        buyItem(upgradeStat, upgradeCost, 1);
                                    }}
                                />
                            )}
                        </Container>
                    </Container>
                ) : (
                    <Panel
                        rounding={4}
                        height={75}
                        justifyContent={Justify.Center}
                        alignContent={Align.FlexStart}
                        padding={10}
                        backgroundColor={colorSwatch.Window}
                        margin={10}
                    >
                        <Text fontSize={20} textAlign="center">
                            {Localization.instance.get('ComingSoon')}
                        </Text>
                    </Panel>
                )}
            </Column>
        </ShoppeBase>
    );
};
